import React, { Component } from "react";
import "./SupplierUserVendorAccess.scss";
import IGetVendorsDTO from "../../../../../models/DTO/IGetVendorsDTO";
import IOnGetVendorsDTO from "../../../../../models/DTO/IOnGetVendorsDTO";
import EndpointsEnum from "../../../../../models/EndpointsEnum";
import IConnection_Token from "../../../../../models/IConnection_Token";
import IConnection_TokenUI from "../../../../../models/IConnection_TokenUI";
import ISupplierModel from "../../../../../models/ISupplierModel";
import IUserUI from "../../../../../models/IUserUI";
import OwLabel from "../../../../shared/OwLabel/OwLabel";
import OwPickList from "../../../../shared/OwPickList/OwPickList";
import * as _ from "lodash-es";
import { Socket } from "socket.io-client";

type Props = {
    workingOnUser: IConnection_TokenUI;
    supplierVendorTokens: IConnection_Token[];
    saveSelectedVendorsFn: (userGuid: string, selectedVendors: any) => void;
    socket: Socket;
    supplierModel: ISupplierModel;
    userModel: IUserUI;
};

type State = {
    availableOptions: any;
    userModel?: IUserUI;
    supplierModel?: ISupplierModel;
};

class SupplierUserVendorAccess extends Component<Props, State> {
    static defaultProps = {
        workingOnUser: {},
        supplierVendorTokens: [],
    };

    readonly state: State = {
        availableOptions: this.props.supplierVendorTokens,
    };

    async componentDidMount() {
        this.props.socket.on(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);

        this.getAllSupplierVendors();
    }

    componentWillUnmount() {
        this.props.socket.removeListener(EndpointsEnum.VendorsOnGetVendors, this.onGetVendors);
    }

    getAllSupplierVendors = () => {
        const payload: IGetVendorsDTO = {
            userGuid: this.props.userModel.guid,
            userToken: this.props.userModel.token,
            supplierGuid: this.props.supplierModel.guid,
            nameGuidOnly: true,
            offset: 0,
            limit: 1500,
        };

        this.props.socket.emit(EndpointsEnum.VendorsGetVendors, payload);
    };

    onGetVendors = (data: IOnGetVendorsDTO) => {
        this.setState({
            availableOptions: data.supplierVendorTokens,
        });
    };

    render() {
        if (
            _.isNil(this.state.availableOptions) ||
            !this.state.availableOptions.length ||
            _.isNil(this.props.workingOnUser) ||
            _.isNil(this.props.workingOnUser["selectedVendors"])
        ) {
            return null;
        }

        const workingOnUser = this.props.workingOnUser || {};

        let selectedVendors: { Vendor: { name: string; guid: string } }[] = [];

        if (!_.isNil(workingOnUser.selectedVendors)) {
            selectedVendors = workingOnUser.selectedVendors.map((selectedVendor) => {
                return {
                    Vendor: {
                        name: selectedVendor.name || "",
                        guid: selectedVendor.guid || "",
                    },
                };
            });
        }

        if (!this.props.workingOnUser) {
            return null;
        }

        return (
            <div className="SupplierUserVendorAccess">
                <div>
                    <OwLabel
                        title={"edit_vendor_access"}
                        isSupplierVendorOverride={true}
                        supplierModel={this.props.supplierModel}
                        postText={":"}
                        className={"me-2"}
                    />
                    {this.props.workingOnUser.User?.name}
                </div>
                <div className={"pick-list-wrapper"}>
                    <OwPickList
                        availableOptions={this.state.availableOptions}
                        titleProp={"Vendor.name"}
                        valueProp={"Vendor.guid"}
                        selectedOptions={selectedVendors}
                        saveFn={(selectedVendors: any) => {
                            this.props.saveSelectedVendorsFn(this.props.workingOnUser.User!.guid, selectedVendors);
                        }}
                    />
                </div>
            </div>
        );
    }
}

export default SupplierUserVendorAccess;
